const baseSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  centerMode: false,
  lazyLoad: true,
  arrows: true,
};

export const Settings = {
  ...baseSettings,
  responsive: [
    {
      breakpoint: 1279,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerMode: false,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '16px',
        dots: true,
        arrows: false,
      },
    },
  ],
};
